import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { AppService } from '../../app.service';

/**
 * Basic authentication guard.
 * Checks that the app has completed initialization and user settings are loaded.
 * Redirects to /loggedOut when no user session is detected.
 */
@Injectable({ providedIn: 'root' })
export class AuthGuard  {
  constructor(private appService: AppService, private router: Router) {}

  canActivate(): boolean {
    if (this.isLocalHost()) {
      return true;
    }

    const hasSession = !!this.appService.USER_SETTINGS?.user?.sso_id;

    if (hasSession) {
      return true;
    }

    this.router.navigate(['/loggedOut']);
    return false;
  }

  private isLocalHost(): boolean {
    return window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';
  }
}
